import React, { useEffect, useState } from "react";

import SidebarSubMenu from "./SidebarSubMenu";
import "./SideBar.css";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import { useTranslation } from "react-i18next";
import { FiMenu } from "react-icons/fi";
import MenuServices from "services/MenuServices";
import * as FiIcons from "react-icons/fi";
import { useLocation } from "react-router-dom";

const Sidebar = () => {
  const [isSidebarClosed, setIsSidebarClosed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 720);

  const { t } = useTranslation();

  const functionToggleSidebar = () => {
    setIsSidebarClosed((prev) => !prev);
  };

  const [sidebarData, setSidebarData] = useState([]);
  const [, setLoading] = useState(true);

  const location = useLocation();
  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const adminInfo = localStorage.getItem("adminInfo")
          ? JSON.parse(localStorage.getItem("adminInfo"))
          : null;
        const response = await MenuServices.getAllAdminMenu();

        if (response.status) {
          let processedData = response.data;

          if (adminInfo?.id !== 1 && adminInfo?.permission) {

            const filterMenuItems = (menuItems) => {
              return menuItems
                .map((menuItem) => {
                  // Normalize names for comparison
                  const normalize = (name) =>
                    name.toLowerCase().replace(/[\s-]+/g, "");

                  // Check permission for the menu item
                  const permission = adminInfo.permission.find(
                    (perm) =>
                      normalize(perm.id_tab) === normalize(menuItem.name)
                  );

                  // If no permission OR view !== 1, remove menu
                  if (!permission || permission.view !== 1) return null;

                  // Recursively filter submenus
                  let filteredSubRoutes = [];
                  if (menuItem.route && menuItem.route.length > 0) {
                    filteredSubRoutes = filterMenuItems(menuItem.route);
                  }

                  // If menu has no visible submenus AND no direct access, remove it
                  if (filteredSubRoutes.length === 0 && !permission.view)
                    return null;

                  return { ...menuItem, route: filteredSubRoutes };
                })
                .filter(Boolean); // Remove null items
            };

            processedData = filterMenuItems(processedData);
          }

          setSidebarData(processedData);
        } else {
          // console.log("Response status is false:", response);
        }
      } catch (error) {
        console.error("Failed to fetch menu data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMenu();
  }, []);




  return (
    <>


      <div
        className={`sidebar ${isSidebarClosed ? isMobile ? "close hidden" : "close" : ""
          } bg-gray-50 dark:bg-gray-900 `}
      >
        <div
          className="py-5 pl-5 gap-x-3 inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-green-700 dark:hover:text-gray-200 cursor-pointer"
          onClick={functionToggleSidebar}
        >
          <FiMenu
            className="w-5 h-5"
            style={{ color: "rgb(14 159 110)" }}
          />
          {/* {isSidebarClosed ? (
                ""
              ) : (
                <span className="ml-1 dark:text-gray-200 text-green-700 flex items-center">
                  Collapse
                </span>
              )} */}
        </div>

        <ul className="nav-links">
          {sidebarData ? (
            sidebarData.map((route) =>
              route.route && route.route.length > 0 ? (
                <SidebarSubMenu
                  key={route.name}
                  route={route}
                  isSidebarClosed={isSidebarClosed}
                />
              ) : (
                <li key={route.path || route.name}>
                  <NavLink
                    exact
                    to={route.path || "#"}
                    target={route?.outside ? "_blank" : "_self"}
                    className={({ isActive }) =>
                      `px-6 py-4 inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-green-700 dark:hover:text-gray-200`
                    }
                  >
                    {location.pathname === route.path && (
                      <span
                        className="absolute inset-y-0 left-0 w-1 bg-green-500 rounded-tr-lg rounded-br-lg"
                        aria-hidden="true"
                      ></span>
                    )}

                    {/* Menu icon: a react-icons/fi name stored in menu.icon.
                            Every menu has one now, so labels line up. */}
                    {route.icon && FiIcons[route.icon] ? (
                      React.createElement(FiIcons[route.icon], {
                        className: `w-5 h-5 flex-shrink-0 ${isSidebarClosed ? "" : "mr-3"}`,
                        "aria-hidden": "true",
                      })
                    ) : (
                      <></>
                    )}
                    {!isSidebarClosed && (
                      <span className="hover:text-green-700 dark:hover:text-gray-200 dark:text-gray-200">
                        {t(`${route.name}`)}
                      </span>
                    )}
                  </NavLink>
                </li>
              )
            )
          ) : (
            <p>Loading sidebar...</p>
          )}
        </ul>
      </div>

    </>
  );
};

export default Sidebar;